import { Component, Inject, OnDestroy, ViewEncapsulation, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';

import { MENU_TOKEN, MenuService } from '@awp/app-common';
import { CurrentMenuQuery } from '@awp/content-router';
import { MenuItem } from '@awp/models';
import { AppConfig } from '@awp/core/config';



@Component({
  selector: 'ap-site-layout',
  templateUrl: './site-layout.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SiteLayoutComponent implements OnDestroy {

  currentMenu: MenuItem;
  regioncode = this.injector.get(AppConfig).REGION_CODE;
  public menuItems: Observable<MenuItem[]>;

  constructor(currentMenuQuery: CurrentMenuQuery, private injector: Injector,
    @Inject(MENU_TOKEN) menuService: MenuService) {

    this.menuItems = menuService.values.pipe(
      map(p => {
        return p.filter(x => !x.hideInNav);
      }),
      shareReplay()
    );

    currentMenuQuery.values
      .pipe(
        distinctUntilChanged(),
        untilDestroyed(this))
      .subscribe(menu => {
        this.currentMenu = menu;
      });
  }

  ngOnDestroy(): void { }

}
